import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { first } from 'rxjs/operators';
import { Team } from 'src/app/shared/models/type-list';
import { WorkService } from '../services/work.service';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, DatePipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

export interface TeamLog {
  timestamp: Date;
  userid: string;
  action: string [];
  user_name: string;
}

@Component({
    selector: 'app-log-dialog.component',
    templateUrl: './log-dialog.component.html',
    styleUrls: ['./log-dialog.component.scss'],
    imports: [MatDialogTitle, MatIcon, CdkScrollable, MatDialogContent, NgIf, MatProgressSpinner, MatInput, FormsModule, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions, DatePipe]
})
export class LogDialog implements OnInit {
  dataSource: MatTableDataSource<TeamLog>;
  loadedRecords: number=0;
  loading:boolean=true;
  records:number=100;

  displayedColumns: string[] = ["Timestamp", "User", "Action"];

  constructor(
              private workService: WorkService,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<LogDialog>,
              @Inject(MAT_DIALOG_DATA) public inData:Team
              ) {}

  ngOnInit(): void {
    this.getLog();
  }

  getLog() {
    this.workService.getTeamLog(this.inData.team_id, this.inData.version_id, this.records, this.inData.log_type).pipe(first()).subscribe( out => { 
      console.debug("getLog", out);
      this.dataSource = out['Body'];
      this.loadedRecords = out['Body'].length;
      this.loading = false;

    });
  }

  onNoClick():void {
    this.dialogRef.close();
  }

}
